import { useEffect, useState } from "react";
import { RefreshCw } from "lucide-react";
import { api } from "@/lib/api";
import HeroActiveSpotlight from "@/components/HeroActiveSpotlight";
import { SampleFormulaTable } from "./SampleFormulaTable";

export const SampleFormula = () => {
  const [ingredients, setIngredients] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [attempt, setAttempt] = useState(0);
  useEffect(() => {
    let active = true;
    setLoading(true);
    setError(false);
    api.products().then(data => {
      if (!Array.isArray(data.ingredients) || !data.ingredients.length) throw new Error("Formula unavailable");
      if (active) setIngredients(data.ingredients);
    }).catch(() => { if (active) setError(true); })
      .finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, [attempt]);
  return (
    <section id="full-ingredient-stack" tabIndex={-1} aria-labelledby="sample-formula-title" className="scroll-mt-8 border-t border-[color:var(--line)] bg-[#faf9f5] text-[#0f0f10]" data-testid="sample-formula-section">
      <div className="mx-auto max-w-site px-6 py-20 md:px-10 md:py-28">
        <div className="mb-12 grid grid-cols-1 gap-10 md:grid-cols-12">
          <div className="md:col-span-4"><div className="flex flex-wrap items-center gap-3 label" data-testid="sample-formula-section-label"><span className="font-mono" data-testid="sample-formula-index">05 / Formula</span><span className="h-px w-8 bg-[#0f0f10]/40" aria-hidden="true" /><span data-testid="sample-formula-kicker">Named actives, key doses.</span></div></div>
          <div className="md:col-span-8">
            <h2 id="sample-formula-title" className="font-display text-3xl leading-[1.05] sm:text-4xl lg:text-5xl" data-testid="sample-formula-title">The full Vitura Performance™ Blend, <span className="editorial normal-case">named in descending dose order.</span></h2>
            <p className="mt-5 max-w-xl text-[15px] leading-relaxed text-[color:var(--ink-2)]" data-testid="sample-formula-intro">Fifteen clinical actives inside one 2,008 mg blend. We name every ingredient and call out the researched doses that carry the clinical claims. Every batch independently verified by EUROFINS.</p>
          </div>
        </div>
        {loading ? <div role="status" className="flex min-h-56 items-center gap-3 text-sm" data-testid="sample-formula-loading"><RefreshCw size={16} className="animate-spin" aria-hidden="true" />Loading the formula…</div> : error ?
          <div role="alert" className="min-h-56 border-y border-[color:var(--line)] py-8" data-testid="sample-formula-error"><p className="text-sm">The formula couldn’t load. Please try again.</p><button type="button" className="mt-4 inline-flex items-center gap-2 border-b border-[#0f0f10] pb-1 text-sm transition-opacity hover:opacity-60" onClick={() => setAttempt(value => value + 1)} data-testid="sample-formula-retry"><RefreshCw size={14} />Try again</button></div> : <>
            <div className="mb-8" data-testid="sample-formula-spotlight"><HeroActiveSpotlight ingredients={ingredients} mobileSafe /></div>
            <SampleFormulaTable ingredients={ingredients} />
          </>}
      </div>
    </section>
  );
};